/**
 * A naive slugify function.
 *
 * Returns a reformatted version of the provided string fit for URLs
and element IDs.
 *
 * @param {string} str
 */
export function slugify(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Invalid argument supplied to slugify()')
  }
  return str.replace(/[-\s\W]+/g, '-').toLowerCase()
}

/**
 * A naive unique id function.
 *
 * Returns a unique id string optionally prefixed with the provided argument.
 */
export const uniqueId = (() => {
  let id = -1
  /** @param {string} [prefix] */
  return (prefix = 'id') => `${prefix}-${++id}`
})()
